import { useEffect, useState } from 'react';

export function useResendCountdown(initialSeconds = 120) {
    const [counter, setCounter] = useState(initialSeconds);

    useEffect(() => {
        if (counter <= 0) {
            return undefined;
        }
        const id = setTimeout(() => setCounter((value) => value - 1), 1000);
        return () => clearTimeout(id);
    }, [counter]);

    const reset = () => setCounter(initialSeconds);

    const stop = () => setCounter(0);

    return { counter, reset, stop, canResend: counter === 0 };
}
